<template>
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 0;padding-bottom: 0">
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="key" placeholder="请输入">
              <el-input v-model="form.key"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="申请时间 :" prop="time">
              <el-date-picker v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row type="flex">
          <el-button class="mr-20" :class="{ 'el-primary-border': chooseRowIds }" :disabled="!chooseRowIds" @click="pass(chooseRowIds)">
            批量审核通过
          </el-button>

          <el-button class="mr-20" :class="{ 'el-primary-border': chooseRowIds }" :disabled="!chooseRowIds" @click="issuePass(chooseRowIds)">
            批量发放资料
          </el-button>

          <el-button @click="exportList" :class="{ 'el-primary-border': chooseRowIds }" :disabled="!chooseRowIds">
            <i class="el-icon-download"></i>&nbsp;导出
          </el-button>

          <!-- <el-upload class="avatar-uploader" action="/singleMuseum/v2/bsVolunteerV2Student/export" accept=".pdf, .doc, .docx, .xls, .xlsx" :data="configData" :show-file-list="false" :on-success="handleAudioSuccess">
            <el-button class="el-primary-border">
              <i class="el-icon-upload"></i>&nbsp;导入
            </el-button>
          </el-upload> -->

          <!-- <el-button @click="exportList" :class="{'el-primary-border':chooseRowIds}" :disabled="!chooseRowIds" >
            <i class="el-icon-download"></i>&nbsp;导出
          </el-button> -->
        </el-row>
      </div>
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" @selection-change="handleSelectionChange" stripe :data="tableData">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <!-- <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
</el-table-column> -->
          <el-table-column prop="adultId" label="姓名" min-width="15%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="exhibitionId" label="申请展览名称" min-width="20%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyTime" label="申请时间" min-width="20%"></el-table-column>
          <el-table-column label="申请结果" min-width="15%" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.result | filterResult }}</template>
          </el-table-column>

          <el-table-column label="资料发送" min-width="15%" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.status | filterStatus }}</template>
          </el-table-column>

          <el-table-column fixed="right" min-width="15%" label="操作">
            <template slot-scope="scope">
              <span v-if="scope.row.result == 0">
                <a class="m-btn mr-10" @click="pass(scope.row.id)">通过</a>
                <a class="m-btn m-danger mr-10" @click="refuse(scope.row)">驳回</a>
              </span>

              <span v-if="scope.row.status == 0 || scope.row.status == ''">
                <a class="m-btn mr-10" @click="issuePass(scope.row.id)">资料发放</a>
                <!-- <a class="m-btn m-danger mr-10" @click="refuse(scope.row)">驳回</a> -->
              </span>

              <span v-if="scope.row.result != 0 && scope.row.status == 1">-</span>
            </template>

          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      form: {
        key: '',
        time: ''
      },
      configData: {
        tableName: 'volunteer'
      },
      listLoading: false,
      tableData: [],
      levelList: [],
      detailData: {},
      listQuery: {
        currentPage: 1,
        size: 10
      },
      chooseRowIds: '',
      total: 0,
      dialogVisible: false
    }
  },

  filters: {
    filterResult(result) {
      if (result == 0) {
        return '审核中'
      } else if (result == 1) {
        return '审核通过'
      } else if (result == 2) {
        return '审核不通过'
      } else if (result == 3) {
        return '取消申请'
      }

      return result
    },

    filterStatus(status) {
      if (status == 0 || status == null) {
        return '未发放'
      } else if (status == 1) {
        return '已发放'
      }

      return status
    }
  },

  methods: {
    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_grade']
        })
        .then((res) => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.levelList = firstArr.concat(state['volunteer_grade'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    initData() {
      this.listLoading = true
      this.$api.volunteer
        .getApplyExhibitionList({
          ...this.form,
          ...this.listQuery
        })
        .then((res) => {
          if (res.success) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
          this.listLoading = false
        })
        .catch((err) => {
          this.listLoading = false
        })
    },

    exportList() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要导出的志愿者')
        return
      }
      location.href =
        '/singleMuseum/v2/bsVolunteerV2ApplyExhibition/export?ids=' +
        this.chooseRowIds +
        '&currentPage=' +
        this.listQuery.currentPage +
        '&size=' +
        this.listQuery.size
      // this.$api.volunteer.exportAdultList({ids:this.chooseRowIds}).then(res=>{
      //   console.log(res)
      // })
    },

    issuePass(ids) {
      this.$common.confirm(
        {
          title: `是否发放资料？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer
            .issueApplyExhibition({
              ids: ids
            })
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message || '设置成功')
                this.getTableList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    // 是否通过审核
    pass(ids) {
      this.$common.confirm(
        {
          title: `是否通过审核？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer
            .passApplyExhibition({
              ids: ids
            })
            .then((res) => {
              if (res.success) {
                this.$message.success('审核通过')
                this.getTableList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    refuse(obj) {
      this.$common.confirm(
        {
          title: `是否驳回审核？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer
            .notPassApplyExhibition({
              ids: obj.id
            })
            .then((res) => {
              if (res.success) {
                this.$message.success('审核驳回')
                this.getTableList()
              }
            })
        }
      )
    },

    getTableList() {
      this.listQuery.currentPage = 1
      this.initData()
    },

    restList() {
      this.$refs.form.resetFields()
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach((item) => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },

  mounted() {
    this.initData()
    this.getDropdownValue()
    window.addEventListener('keyup', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
.com-search-box {
  /deep/ .el-col {
    margin-bottom: 30px;
  }
}

/deep/ .table{
  .el-table-column--selection{
    .cell{
      padding-left: 14px;
      padding-right: 14px;
    }
  }
}
</style>